import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TmPageNotFoundComponent } from '@classifieds-sell/trademe-core-ui';
import { CategoryEnum } from 'libs/datalayer/src';
import { boatsAndMarineRoutes } from './category-routes/boats-and-marine-routes';
import { MotorsHomeComponent } from './components/motors-home/motors-home.component';
import { MotorsLandingComponent } from './components/motors-landing/motors-landing.component';
import { AuthGuard } from '@classifieds-sell/auth';
import { MotorsUiRouteGuard } from './guards/motors-ui-route.guard';

// this configuration should be playing along with guards and logic in landing component
export const motorsUiRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: MotorsLandingComponent,
        children: [
            {
                path: `${CategoryEnum.boatsAndMarineMotorboats.toString()}`,
                children: boatsAndMarineRoutes,
                data: {
                    categoryId: CategoryEnum.boatsAndMarineMotorboats
                },
                component: MotorsHomeComponent,
                canActivate: [MotorsUiRouteGuard]
            },
            {
                path: `${CategoryEnum.boatsAndMarineMotorboats.toString()}/edit/:listingId`,
                children: boatsAndMarineRoutes,
                data: {
                    categoryId: CategoryEnum.boatsAndMarineMotorboats,
                    editing: true
                },
                component: MotorsHomeComponent,
                canActivate: [MotorsUiRouteGuard]
            },
            {
                path: `${CategoryEnum.boatsAndMarineMotorboats.toString()}/relist/:listingId`,
                children: boatsAndMarineRoutes,
                data: {
                    categoryId: CategoryEnum.boatsAndMarineMotorboats,
                    relisting: true
                },
                component: MotorsHomeComponent,
                canActivate: [MotorsUiRouteGuard]
            },
            {
                path: '**',
                component: TmPageNotFoundComponent
            } // this is needed due to design of our parents and children routes and router-outlets
        ]
    },
    {
        path: '**',
        component: TmPageNotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(motorsUiRoutes)],
    exports: [RouterModule],
    providers: []
})
export class MotorsUiRouteModule { }
